import { BaseItemStore } from "../../core/BaseStore";
import type { BusinessPlanModel } from "./BusinessPlanModel";

export default class BusinessPlansStore extends BaseItemStore<BusinessPlanModel> {}
